export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9187.f1456f4c.jpg";